module.exports = {
  en: {
    localeSelector: {
      labelText: 'Choose a language'
    },
    'home': 'Main Menu',
    'showNarration': 'Show',
    'hideNarration': 'Hide',
    'narrationCaption': 'Narration',
    'pause': 'Pause audio',
    'resume': 'Resume audio',
    'replay': 'Replay audio',
    'reload': 'Replay audio',
    'play': 'Play',
    'muteOn': 'Turn Audio On',
    'muteOff': 'Turn Audio Off',
    'mute': 'Mute',
    'transcriptClose': 'Close transcript',
    'portraitModeWarning': 'This course is optimized on mobile to be viewed in landscape mode, please try rotating your device.',
    'okButton': 'OK',
    'secondaryNavigationLabel': 'Secondary Navigation',
    'backButton': 'Previous Page',
    'forwardPopover': 'Page is done, time to go to the next one!',
    'forwardButton': 'Next Page',
    'portfolioButton': 'Portfolio',
    'portfolioButtonOpen': 'Close Portfolio',
    'surveyRedirectLocal': 'If you weren\'t local you\'d be redirected to survey',
    'clickToProceed': 'Click Here to Proceed',
    'assessmentRedirect': 'You are being directed to an assessment.',
    'surveyAlreadyCompleted': 'You have already completed this survey',
    'surveyRedirect': 'You are being directed to a survey.',
    'surveyRedirectText': 'If you are not directed in 5 seconds',
    'surveyRedirectLinkText': 'click here',
    'srSkipText': 'Press shift plus control plus {{accessibility.skipKey}} to continue to the next page when you are ready.',
    'clickToSign': 'Click to e-sign (required)',
    'signedMessage': 'Thanks for signing!',
    'defaultESigBody': 'Click the link above before e-signing.',
    'videoKeyboardShortcutsButton': 'Keyboard Shortcuts',
    'videoKeyboardShortcuts': '<p>Use Space or Enter to pause/play the video.</p><p>Use M to mute/unmute the video.</p><p>Use Up Arrow and Down Arrow to increase/decrease the volume.</p><p>Use C to show/hide the captions.</p>',
    'videoKeyboardShortcutsClose': 'Close',
    'submitbtn': 'Submit',
    'closeModal': 'Close',
    'openMenu': 'open menu',
    'close_resource_btn': 'close',
    'currentLanguage': 'English',
    'off': 'Off',
    'loadingPage': 'A new page is loading',
    'alertBox': {
      'alertSuccessHeader': 'Submitted successfully!',
      'alertSuccessText': 'You may proceed with the course.',
      'alertFailureHeader': 'Something went wrong...',
      'alertFailureText': 'An error occurred while submitting this policy, please try again. If you encounter any issues completing the course please contact an administrator.',
      'alertClose': 'close'
    },
    'mediaAccessibility': {
      'completed': 'Media completed, click to Replay',
      'playing': 'Media playing, click to Pause',
      'stopped': 'Media stopped, click to Play',
      'paused': 'Media stopped, click to Play',
      'none': 'Media unavailable'
    },
    'audioAccessibility': {
      'playing': 'Audio Playing, Select to Pause',
      'paused': 'Audio Paused, Select to Play',
      'stopped': 'Audio Stopped, Select to Play',
      'completed': 'Audio Complete, Select to Replay',
      'aria-playing': 'Audio Playing, Select to Pause',
      'aria-paused': 'Audio Paused, Select to Play',
      'aria-stopped': 'Audio Stopped, Select to Play',
      'aria-completed': 'Audio Complete, Select to Replay'
    },
    'videoAccessibility': {
      'pause': 'Pause video',
      'play': 'Play video',
      'stopped': 'Video stopped, click to play',
      'playpause': 'Click to pause or play media',
      'start': 'Click to start',
      'mute': 'Mute video',
      'unmute': 'Unmute the video',
      'time': 'Current media time',
      'seeker': 'Video progress bar',
      'duration': 'Media duration',
      'captions': 'Toggle media captions',
      'volumebar': 'Adjust volume of media',
      'tracks': 'Switch A/V tracks in media',
      'bitrate': 'Switch bit rate of media',
      'autoSwitch': 'Auto Switch',
      'fullscreen': 'Toggle fullscreen of media',
      'keyboardShortcutsButton': 'Keyboard Shortcuts',
      'keyboardShortcuts': '<p>Use Space or Enter to pause/play the video.</p><p>Use M to mute/unmute the video.</p><p>Use Up Arrow and Down Arrow to increase/decrease the volume.</p><p>Use C to show/hide the captions.</p>',
      'keyboardShortcutsClose': 'Close',
      'playerInstructions1': 'This is a video player on ',
      'playerInstructions2': 'Use Space or Enter to pause/play the video. Use M to mute/unmute the video. Use C to show/hide the captions. Use F to go Fullscreen. Use Up Arrow and Down Arrow to increase/decrease the volume. Use Right Arrow and Left Arrow to skip forward/backward.',
      'minutes': 'minutes',
      'seconds': 'seconds',
      'timeLabel': '{{currentTime}} of {{duration}}',
      'currentTimeLabel': 'Current media time is {{currentTime}}',
      'durationTimeLabel': 'Media duration: {{duration}}'
    },
    'audioFailedAlert': 'An audio file failed to start, use this button to try restarting it:',
    'startAudioButton': 'Start Audio',
    'actionPlan': {
      'viewMyPlan': 'Continue',
      'summaryText': 'Congratulations on completing your Action Plan! Select Continue to view your plan and have it emailed to you.',
      'stepDone': 'Done',
      'completeTitle': 'Action Plan Complete',
      'sendEmail': 'Email me my action plan',
      'emailErrorMessage': 'Please enter a valid email address.',
      'emailPlaceholder': 'email address',
      'subheader': 'Building Action Plan',
      'stepsComplete': 'Step {{currentStep}} of {{totalSteps}}'
    },
    'actionPlanResponses': {
      'subheader': 'Viewing Action Plan',
      'stepsComplete': '{{doneTotal}} of {{responseTotal}} complete',
      'now': 'now',
      'later': 'later',
      'done': 'Done',
      'incomplete': 'Please finish the module in order to build your Action Plan.'
    },
    'dragAndDrop': {
      'single': 'This is a draggable element. You can also use the keyboard to make selections - press ENTER to move this item to the correct drop spot.',
      'multiple': 'This is a draggable element. If you would like to move draggable elements using a keyboard: press tab key to move among elements, press the enter key to select an element, and then press the {{firstOption}} or {{lastOption}} keys to move and the drop the element.',
      'default': 'Drop spot',
      'linkWord': 'for',
      'dropped': 'This draggable element is now dropped.',
      'dropSpotTaken': 'Drop spot already taken.',
      'success': 'Drag element dropped successfully.',
      'incorrect': 'Drag element not dropped. Incorrect drop spot.',
      'kbInstructions': 'Press a key from {{firstChar}} to {{lastChar}} to move this item to the matching block.',
      'kbtext': 'Press the {{keyChar}} key to match with the following block: {{text}}',
      'correct': 'That is the correct match!'
    },
    'moduleProgress': '{{completedModules}} out of {{totalModules}}',
    'accordion': {
      'bellowCollapsed': 'Currently collapsed, press enter to expand this selection.',
      'bellowVisitedCollapsed': 'Visited Collapsed',
      'bellowVisitedExpanded': 'Currently Open',
    },
    'tabText': 'tab {{tabIndex}} of {{tabLength}}',
    'completed': 'completed',
    'notCompleted': 'Not completed',
    'currentPage': 'current page',
    'carousel': {
      'next': 'Next',
      'previous': 'Previous',
      'slickDotAriaLabel': 'Slide'
    },
    'inputErrorMessages': {
      'title': 'There are some invalid values in the form',
      'desc_between': '{{ fieldName }}: The correct value should be between {{ min }} and {{ max }}',
      'desc_lower': '{{ fieldName }}: The correct value should be lower than {{ max }}',
      'desc_higher': '{{ fieldName }}: The correct value should be higher than {{ min }}'
    },
    'courseMenu': {
      'closeMenu': 'close menu',
      'navigateBackward': 'navigate menu backward'
    },
    'sort': {
      'grabbed': '{{ srText }} grabbed',
      'dropped': '{{ srText }} dropped',
      'listUpdated': 'List updated. {{srText}} is now {{ position }} of {{ length }}'
    },
    'slider': {
      'decrementBtn': 'Decrement slider',
      'incrementBtn': 'Increment slider'
    },
    'input': {
      'number': {
        'decreaseBtn': 'Decrease number',
        'increaseBtn': 'Increase number'
      }
    },
    'selected': 'selected',
    'link': {
      'newWindowWarning': 'warning: this link opens in new window'
    },
    'advocateChatForm': {
      'screenName': 'What screen name do you want to use?',
      'crisisNow': {
        'label': 'Are you in crisis?',
        'placeholder': 'Required',
        'option1': 'Yes',
        'option2': 'No',
        'option3': 'I\'m not sure'
      },
      'contactAge': {
        'label': 'How old are you?',
        'placeholder': 'Required'
      },
      'contactGender': {
        'label': 'What is your gender?',
        'placeholder': 'Optional',
        'option1': 'Male',
        'option2': 'Female',
        'option3': 'Trans Male',
        'option4': 'Trans Female',
        'option5': 'Two Spirit',
        'option6': 'Non-binary',
        'option7': 'Other'
      },
      'contactRace': {
        'label': 'What is your race / ethnicity?',
        'placeholder': 'Optional',
        'option1': 'Arab / Middle Eastern',
        'option2': 'Asian (East, Southwest, and South)',
        'option3': 'Bi / Multiracial',
        'option4': 'Black / African American',
        'option5': 'Latino / Hispanic',
        'option6': 'Native American / Alaska Native',
        'option7': 'Native Hawaiian / Pacific Islander',
        'option8': 'White / Caucasian',
        'option9': 'Other'
      },
      'howHeard': {
        'label': 'How did you hear about us?',
        'placeholder': 'Custom Data',
        'option1': 'Court / Legal',
        'option2': 'DV / Social Services Program',
        'option3': 'EAP / HR',
        'option4': 'Internet / Search Engine',
        'option5': 'Law Enforcement',
        'option6': 'Marshalls / HomeGoods / TJ Maxx',
        'option7': 'Mary Kay',
        'option8': 'Media - Printed',
        'option9': 'Media - TV / Radio',
        'option10': 'Medical / Health',
        'option11': 'MTV',
        'option12': 'NO MORE',
        'option13': 'Other',
        'option14': 'Religious Leader/Program',
        'option15': 'School',
        'option16': 'Social Media',
        'option17': 'Word of Mouth'
      },
      'repeatContact': {
        'label': 'Have you chatted with an advocate in the past?',
        'placeholder': 'Custom Data',
        'option1': 'Yes',
        'option2': 'No',
        'option3': 'I\'m not sure'
      }
    },
    'advocateChat': {
      'calendar': {
        'CalendarDayLabels': [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ],
        'CalendarMonthLabels': [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sept',
          'Oct',
          'Nov',
          'Dec'
        ],
        'CalendarLabelToday': 'Today',
        'CalendarLabelTomorrow': 'Tomorrow',
        'CalendarTitle': 'Schedule a Call',
        'CalendarOkButtonText': 'Okay',
        'CalendarError': 'Unable to fetch availability details.',
        'CalendarClose': 'Cancel',
        'AriaWindowTitle': 'Calendar Window',
        'AriaCalendarClose': 'Cancel',
        'AriaYouHaveChosen': 'You have chosen',
        'AriaNoTimeSlotsFound': 'No time slots found for selected date'
      },
      'callus': {
        'CallUsTitle': 'Call Us',
        'ContactsHeader': 'You can reach us at any of the following numbers...',
        'CancelButtonText': 'Cancel',
        'CoBrowseText': '<span class=\'cx-cobrowse-offer\'>Already on a call? Let us <a role=\'link\' tabindex=\'0\' class=\'cx-cobrowse-link\'>browse with you</a></span>',
        'CoBrowse': 'Start Co-browse',
        'CoBrowseWarning': 'Co-browse allows your agent to see and control your desktop, to help guide you. When on a live call with an Agent, request a code to start Co-browse and enter it below. Not yet on a call? just cancel out of this screen to return to Call Us page.',
        'SubTitle': 'You can reach us at any of the following numbers...',
        'AriaWindowLabel': 'Call Us Window',
        'AriaCallUsClose': 'Call Us Close',
        'AriaBusinessHours': 'Business Hours',
        'AriaCallUsPhoneApp': 'Opens the phone application',
        'AriaCobrowseLink': 'Opens the Co-browse Session',
        'AriaCancelButtonText': 'Cancel'
      },
      'callback': {
        'CallbackTitle': 'Receive a Call',
        'CancelButtonText': 'Cancel',
        'AriaCancelButtonText': 'Cancel',
        'ConfirmButtonText': 'Confirm',
        'AriaConfirmButtonText': 'Confirm',
        'CallbackFirstName': 'First Name',
        'CallbackPlaceholderRequired': 'Required',
        'CallbackPlaceholderOptional': 'Optional',
        'CallbackLastName': 'Last Name',
        'CallbackPhoneNumber': 'Phone',
        'CallbackQuestion': 'When should we call you?',
        'CallbackDayLabels': [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ],
        'CallbackMonthLabels': [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        'CallbackConfirmDescription': 'You\'re booked in!',
        'CallbackNumberDescription': 'We will call you at the number provided:',
        'CallbackNotes': 'Notes',
        'CallbackDone': 'Close',
        'AriaCallbackDone': 'Close',
        'CallbackOk': 'Okay',
        'AriaCallbackOk': 'Okay',
        'CallbackCloseConfirm': 'Are you sure you want to cancel arranging this callback?',
        'CallbackNoButtonText': 'No',
        'AriaCallbackNoButtonText': 'No',
        'CallbackYesButtonText': 'Yes',
        'AriaCallbackYesButtonText': 'Yes',
        'CallbackWaitTime': 'Wait Time',
        'CallbackWaitTimeText': 'min wait',
        'CallbackOptionASAP': 'As soon as possible',
        'CallbackOptionPickDateTime': 'Pick date & time',
        'AriaCallbackOptionPickDateTime': 'Opens a date picker',
        'CallbackPlaceholderCalendar': 'Select Date & Time',
        'AriaMinimize': 'Callback Minimize',
        'AriaWindowLabel': 'Callback Window',
        'AriaMaximize': 'Callback Maximize',
        'AriaClose': 'Callback Close',
        'AriaCalendarClosedStatus': 'Calendar is closed',
        'Errors': {
          '501': 'Invalid parameters cannot be accepted, please check the supporting server API documentation for valid parameters.',
          '503': 'Missing apikey, please ensure it is configured properly.',
          '1103': 'Missing apikey, please ensure it is configured properly.',
          '7030': 'Please enter a valid phone number.',
          '7036': 'Callback to this number is not possible. Please retry with another phone number.',
          '7037': 'Callback to this number is not allowed. Please retry with another phone number.',
          '7040': 'Please configure a valid service name.',
          '7041': 'Too many requests at this time.',
          '7042': 'Office closed. Please try scheduling within the office hours.',
          'unknownError': 'Something went wrong, we apologize for the inconvenience. Please check your connection settings and try again.',
          'phoneNumberRequired': 'Phone number is required.',
          'CallbackDateTimeRequired': 'Select Date & Time'
        }
      },
      'channelselector': {
        'Title': 'Live Assistance',
        'SubTitle': 'How would you like to get in touch?',
        'WaitTimeTitle': 'Wait Time',
        'AvailableTitle': 'Available',
        'AriaAvailableTitle': 'Available',
        'UnavailableTitle': 'Unavailable',
        'CobrowseButtonText': 'CobrowseSubTitle',
        'CallbackTitle': 'Receive a Call',
        'CobrowseSubTitle': 'Agent connection is required for this.',
        'AriaClose': 'Live Assistance Close',
        'AriaWarning': 'Warning',
        'AriaAlert': 'Alert',
        'minute': 'min',
        'minutes': 'mins',
        'AriaWindowLabel': 'Live Assistance Window'
      },
      'clicktocall': {
        'Title': 'ClickToCall',
        'FirstName': 'First Name',
        'PlaceholderRequired': 'Required',
        'PlaceholderOptional': 'Optional',
        'LastName': 'Last Name',
        'PhoneNumber': 'Phone',
        'WaitTime': 'Wait Time',
        'FormCancel': 'Cancel',
        'AriaFormCancel': 'Cancel',
        'FormSubmit': 'Request a number',
        'AriaFormSubmit': 'Request a number',
        'PhoneLabel': 'Dial in now',
        'AriaPhoneTitle': 'Opens the phone application',
        'AccessLabel': 'Access Code',
        'ExpireLabel': 'Number Expires in',
        'AriaExpireLabel': 'Number Expires in Timer',
        'DisplayClose': 'Close',
        'AriaDisplayClose': 'Close',
        'NetworkFail': 'Something went wrong, we apologize for the inconvenience. Please check your connection settings and try again.',
        'NetworkRetry': 'OK',
        'AriaNetworkRetry': 'OK',
        'InvalidAccept': 'OK',
        'AriaInvalidAccept': 'OK',
        'PhoneExpired': 'Phone number has expired!',
        'PhoneReRequest': 'Request a new number',
        'AriaPhoneReRequest': 'Request a new number',
        'LocalFormValidationEmptyPhoneNumber': 'Please enter a phone number',
        'ConfirmCloseWindow': 'You have unsubmitted form data. Are you sure you want to quit?',
        'AriaConfirmCloseCancel': 'No',
        'ConfirmCloseCancel': 'No',
        'AriaConfirmCloseConfirm': 'Yes',
        'ConfirmCloseConfirm': 'Yes',
        'AriaWindowLabel': 'Click To Call Window',
        'AriaMaximize': 'Click To Call Maximize',
        'AriaMinimize': 'Click To Call Minimize',
        'AriaClose': 'Click To Call Close'
      },
      'cobrowse': {
        'agentJoined': 'Representative has joined the session.',
        'youLeft': 'You have left the session. Co-browse is now terminated.',
        'sessionTimedOut': 'Session timed out. Co-browse is now terminated.',
        'sessionInactiveTimedOut': 'Session timed out. Co-browse is now terminated.',
        'agentLeft': 'Representative has left the session. Co-browse is now terminated.',
        'sessionError': 'Unexpected error occured. Co-browse is now terminated.',
        'sessionStarted': 'Co-browse session started. Waiting for representative to connect to the session…',
        'navRefresh': 'Representative has refreshed the page. Reloading.',
        'navBack': 'Representative has pressed the "Back" button. Reloading page.',
        'navForward': 'Representative has pressed the "Forward" button. Reloading page.',
        'navUrl': 'Representative has requested navigation. Reloading page.',
        'navFailed': 'Navigation request by representative has failed.',
        'toolbarContent': 'Session ID: {sessionId}',
        'contentMasked': 'Content is hidden from representative.',
        'contentMaskedPartially': 'Some content is hidden from representative.',
        'exitBtnTitle': 'Exit Co-browse session',
        'areYouOnPhone': 'Are you on the phone with our representative?',
        'areYouOnPhoneOrChat': 'Are you on the phone or chat with our representative?',
        'connectBeforeCobrowse': 'You need to be connected with our representative to continue with co-browsing. Please call us or start a live chat with us, and then start Co-browse again.',
        'sessionStartedAutoConnect': 'Co-browse session started. Waiting for representative to connect to the session…',
        'browserUnsupported': 'Unfortunately, your browser is not currently supported.<br><br> Supported browsers are: <ul><li><a target=\'_blank\' href=\'http://www.google.com/chrome\'>Google Chrome</a></li><li><a target=\'_blank\' href=\'http://www.firefox.com/\'>Mozilla Firefox</a></li><li><a target=\'_blank\' href=\'http://microsoft.com/ie\'>Internet Explorer 9 and above</a></li><li><a target=\'_blank\' href=\'https://www.apple.com/safari\'>Safari 6 and above</a></li></ul>',
        'chatIsAlreadyRunning': 'Chat is already running on another page.',
        'modalYes': 'Yes',
        'modalNo': 'No'
      },
      'knowledgecenter': {
        'SidebarButton': 'Search',
        'SearchButton': 'Search',
        'Title': 'Ask a Question',
        'Ask': 'Ask',
        'AriaAsk': 'Ask',
        'Close': 'Close',
        'AriaClose': 'Close',
        'Categories': 'Categories',
        'NoResults': 'No Results',
        'NoResultsTextUnder': 'We\'re sorry but we could not find a suitable answer for you.',
        'NoResultsTextRephrase': 'Could you please try rephrasing the question?',
        'WasThisHelpful': 'Was this helpful?',
        'Yes': 'Yes',
        'No': 'No',
        'AriaYes': 'Yes',
        'AriaNo': 'No',
        'ArticleHelpfulnessYes': 'Article Helpfulness - \'Yes\'',
        'ArticleHelpfulnessYesDesc': 'Great! We\'re very pleased to hear that the article assisted you in your search. Have a great day!',
        'ArticleHelpfulnessNo': 'Article Helpfulness - \'No\'',
        'ArticleHelpfulnessNoDesc': 'We\'re sorry that the article wasn\'t a good match for your search. We thank you for your feedback!',
        'TypeYourQuestion': 'Type your question',
        'Back': 'Back',
        'AriaBack': 'Back',
        'More': 'More',
        'Error': 'Error!',
        'GKCIsUnavailable': 'Knowledge Center Server is currently not available.',
        'AriaClear': 'Clear',
        'AriaSearch': 'Search',
        'AriaWindowLabel': 'Search Window',
        'AriaSearchDropdown': 'Suggested results',
        'AriaSearchMore': 'Read more about',
        'AriaResultsCount': 'Total number of results',
        'KnowledgeAgentName': 'Knowledge Center',
        'WelcomeMessage': 'Hello and welcome! A Live agent will be with you shortly. In the meantime, can I assist you with any questions you may have? Please type a question into the input field below.',
        'SearchResult': 'While waiting for an Agent to connect, here are the most relevant answers to your query:',
        'NoDocumentsFound': 'I\'m sorry. No articles matched your question. Would you like to ask another question?',
        'SuggestedMessage': 'The following knowledge item has been suggested:',
        'OpenDocumentHint': 'Click on it to view its content.',
        'SuggestedDocumentMessage': 'The document \'<%DocTitle%>\' has been suggested.',
        'FeedbackQuestion': 'Was this helpful?',
        'FeedbackAccept': 'Yes',
        'FeedbackDecline': 'No',
        'TranscriptMarker': 'KnowledgeCenter: ',
        'SearchMessage': 'Search with query \'<%SearchQuery%>\'↲',
        'VisitMessage': 'Visit for document \'<%VisitQuery%>\'',
        'OpenMessage': 'Viewed \'<%OpenQuery%>\'',
        'AnsweredMessage': 'Results for query \'<%AnsweredQuery%>\' have been marked as relevant.',
        'UnansweredMessage': 'Results for query \'<%UnansweredQuery%>\' have been marked as unanswered.',
        'PositiveVoteMessage': 'Positive voting for document \'<%VoteQuery%>\'.',
        'NegativeVoteMessage': 'Negative voting for document \'<%VoteQuery%>\'.',
        'SuggestedMarker': 'The document[^\\0]*?has been suggested.'
      },
      'sendmessage': {
        'SendMessageButton': 'Send Message',
        'OK': 'OK',
        'Title': 'Send Message',
        'PlaceholderFirstName': 'Required',
        'PlaceholderLastName': 'Required',
        'PlaceholderEmail': 'Required',
        'PlaceholderSubject': 'Required',
        'PlaceholderTypetexthere': 'Type your message here...',
        'FirstName': 'First Name',
        'LastName': 'Last Name',
        'Email': 'Email',
        'Subject': 'Subject',
        'Attachfiles': 'Attach files',
        'AriaAttachfiles': 'Attach files link. Open a file upload dialog.',
        'Send': 'Send',
        'AriaSend': 'Send',
        'Sent': 'Your message has been sent...',
        'Close': 'Close',
        'ConfirmCloseWindow': 'Are you sure you want to close the Send Message widget?',
        'Cancel': 'Cancel',
        'AriaMinimize': 'Send Message Minimize',
        'AriaMaximize': 'Send Message Maximize',
        'AriaWindowLabel': 'Send Message Window',
        'AriaClose': 'Close',
        'AriaCloseAlert': 'Alert box is closed',
        'AriaEndConfirm': 'Yes',
        'AriaEndCancel': 'Cancel',
        'AriaOK': 'OK',
        'AriaRemoveFile': 'Remove file',
        'AriaFileIcon': 'File',
        'AriaFileSize': 'File Size',
        'Errors': {
          '102': 'First Name required.',
          '103': 'Last Name required.',
          '104': 'Subject required.',
          '181': 'Email address required.',
          '182': 'Message text content required.',
          'connectionError': 'Unable to reach server. Please try again.',
          'unknownError': 'Something went wrong, we apologize for the inconvenience. Please check your connection settings and try again.',
          'attachmentsLimit': 'Total number of attachments exceeds limit: ',
          'attachmentsSize': 'Total size of attachments exceeds limit: ',
          'invalidFileType': 'Unsupported file type. Please upload images, PDFs, text files and ZIPs.',
          'invalidFromEmail': 'Invalid email - From address.',
          'invalidMailbox': 'Invalid email - To address.'
        }
      },
      'sidebar': {
        'SidebarTitle': 'Need help?',
        'ChannelSelectorName': 'Live Assistance',
        'ChannelSelectorTitle': 'Get assistance from one of our agents right away',
        'SearchName': 'Search',
        'SearchTitle': 'Search',
        'CallUsName': 'Call Us',
        'CallUsTitle': 'Call Us details',
        'CallbackName': 'Callback',
        'CallbackTitle': 'Receive a Call',
        'ClickToCallName': 'ClickToCall',
        'ClickToCallTitle': 'Request a customer service phone number',
        'SendMessageName': 'Send Message',
        'SendMessageTitle': 'Send Message',
        'WebChatName': 'Live Chat',
        'WebChatTitle': 'Live Chat',
        'AriaClose': 'Close the menu Need help'
      },
      'webchat': {
        'ChatButton': 'Chat',
        'ChatStarted': 'Chat Started',
        'ChatEnded': 'Chat Ended',
        'AgentNameDefault': 'Agent',
        'AgentConnected': '<%Agent%> Connected',
        'AgentDisconnected': '<%Agent%> Disconnected',
        'BotNameDefault': 'Bot',
        'BotConnected': '<%Bot%> Connected',
        'BotDisconnected': '<%Bot%> Disconnected',
        'SupervisorNameDefault': 'Supervisor',
        'SupervisorConnected': '<%Agent%> Connected',
        'SupervisorDisconnected': '<%Agent%> Disconnected',
        'AgentTyping': '...',
        'AriaAgentTyping': 'Agent is typing',
        'AgentUnavailable': 'Sorry. There are no agents available. Please try later.',
        'ChatTitle': 'Live Chat',
        'ChatEnd': 'X',
        'ChatClose': 'X',
        'ChatMinimize': 'Min',
        'ChatFormFirstName': 'First Name',
        'ChatFormLastName': 'Last Name',
        'ChatFormNickname': 'Nickname',
        'ChatFormEmail': 'Email',
        'ChatFormSubject': 'Subject',
        'ChatFormPlaceholderFirstName': 'Required',
        'ChatFormPlaceholderLastName': 'Required',
        'ChatFormPlaceholderNickname': 'Optional',
        'ChatFormPlaceholderEmail': 'Optional',
        'ChatFormPlaceholderSubject': 'Optional',
        'ChatFormSubmit': 'Start Chat',
        'AriaChatFormSubmit': 'Start Chat',
        'ChatFormCancel': 'Cancel',
        'AriaChatFormCancel': 'Cancel',
        'ChatFormClose': 'Close',
        'ChatInputPlaceholder': 'Type your message here',
        'ChatInputSend': 'Send',
        'AriaChatInputSend': 'Send',
        'ChatEndQuestion': 'Are you sure you want to end this chat session?',
        'ChatEndCancel': 'Cancel',
        'ChatEndConfirm': 'End chat',
        'AriaChatEndCancel': 'Cancel',
        'AriaChatEndConfirm': 'End chat',
        'ConfirmCloseWindow': 'Are you sure you want to close chat?',
        'ConfirmCloseCancel': 'Cancel',
        'ConfirmCloseConfirm': 'Close',
        'AriaConfirmCloseCancel': 'Cancel',
        'AriaConfirmCloseConfirm': 'Close',
        'ActionsDownload': 'Download transcript',
        'ActionsEmail': 'Email transcript',
        'ActionsPrint': 'Print transcript',
        'ActionsCobrowseStart': 'Start Co-browse',
        'AriaActionsCobrowseStartTitle': 'Opens the Co-browse session',
        'ActionsSendFile': 'Attach Files',
        'AriaActionsSendFileTitle': 'Opens a file upload dialog',
        'ActionsEmoji': 'Send Emoji',
        'ActionsCobrowseStop': 'Exit Co-browse',
        'ActionsVideo': 'Invite to Video Chat',
        'ActionsTransfer': 'Transfer',
        'ActionsInvite': 'Invite',
        'InstructionsTransfer': 'Open this link on another device to transfer your chat session</br></br><%link%>',
        'InstructionsInvite': 'Share this link with another person to add them to this chat session</br></br><%link%>',
        'InviteTitle': 'Need help?',
        'InviteBody': 'Let us know if we can help out.',
        'InviteReject': 'No thanks',
        'InviteAccept': 'Start chat',
        'AriaInviteAccept': 'Start chat',
        'AriaInviteReject': 'No thanks',
        'ChatError': 'There was a problem starting the chat session. Please retry.',
        'ChatErrorButton': 'OK',
        'AriaChatErrorButton': 'OK',
        'ChatErrorPrimaryButton': 'Yes',
        'ChatErrorDefaultButton': 'No',
        'AriaChatErrorPrimaryButton': 'Yes',
        'AriaChatErrorDefaultButton': 'No',
        'DownloadButton': 'Download',
        'AriaDownloadButton': 'Download',
        'FileSent': 'has sent:',
        'FileTransferRetry': 'Retry',
        'AriaFileTransferRetry': 'Retry',
        'FileTransferError': 'OK',
        'AriaFileTransferError': 'OK',
        'FileTransferCancel': 'Cancel',
        'AriaFileTransferCancel': 'Cancel',
        'RestoreTimeoutTitle': 'Chat ended',
        'RestoreTimeoutBody': 'Your previous chat session has timed out. Would you like to start a new one?',
        'RestoreTimeoutReject': 'No thanks',
        'RestoreTimeoutAccept': 'Start chat',
        'AriaRestoreTimeoutAccept': 'Start chat',
        'AriaRestoreTimeoutReject': 'No thanks',
        'EndConfirmBody': 'Would you really like to end your chat session?',
        'EndConfirmAccept': 'End chat',
        'EndConfirmReject': 'Cancel',
        'AriaEndConfirmAccept': 'End chat',
        'AriaEndConfirmReject': 'Cancel',
        'SurveyOfferQuestion': 'Would you like to participate in a survey?',
        'ShowSurveyAccept': 'Yes',
        'ShowSurveyReject': 'No',
        'AriaShowSurveyAccept': 'Yes',
        'AriaShowSurveyReject': 'No',
        'UnreadMessagesTitle': 'unread messages',
        'AriaYouSaid': 'You said',
        'AriaSaid': 'said',
        'AriaSystemSaid': 'System said',
        'AriaWindowLabel': 'Live Chat Window',
        'AriaMinimize': 'Live Chat Minimize',
        'AriaMaximize': 'Live Chat Maximize',
        'AriaClose': 'Live Chat Close',
        'AriaEmojiStatusOpen': 'Emoji picker dialog is opened',
        'AriaEmojiStatusClose': 'Emoji picker dialog is closed',
        'AriaEmoji': 'emoji',
        'AriaCharRemaining': 'Characters remaining',
        'AriaMessageInput': 'Message box',
        'AsyncChatEnd': 'End Chat',
        'AsyncChatClose': 'Close Window',
        'AriaAsyncChatEnd': 'End Chat',
        'AriaAsyncChatClose': 'Close Window',
        'DayLabels': [
          'Sun',
          'Mon',
          'Tue',
          'Wed',
          'Thur',
          'Fri',
          'Sat'
        ],
        'MonthLabels': [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sept',
          'Oct',
          'Nov',
          'Dec'
        ],
        'todayLabel': 'Today',
        'Errors': {
          '102': 'First name is required.',
          '103': 'Last name is required.',
          '161': 'Please enter your name.',
          '201': 'The file could not be sent.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>The maximum number of attached files would be exceeded (<%MaxFilesAllowed%>).</p>',
          '202': 'The file could not be sent.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>Upload limit and/or maximum number of attachments would be exceeded (<%MaxAttachmentsSize%>).</p>',
          '203': 'The file could not be sent.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>File type is not allowed.</p>',
          '204': 'We\'re sorry but your message is too long. Please write a shorter message.',
          '240': 'We\'re sorry but we cannot start a new chat at this time. Please try again later.',
          '364': 'Invalid email address.',
          '401': 'We\'re sorry but we are not able to authorize the chat session. Would you like to start a new chat?',
          '404': 'We\'re sorry but we cannot find your previous chat session. Would you like to start a new chat?',
          '500': 'We\'re sorry, an unexpected error occurred with the service. Would you like to close and start a new Chat?',
          '503': 'We\'re sorry, the service is currently unavailable or busy. Would you like to close and start a new Chat again?',
          'ChatUnavailable': 'We\'re sorry but we cannot start a new chat at this time. Please try again later.',
          'CriticalFault': 'Your chat session has ended unexpectedly due to an unknown issue. We apologize for the inconvenience.',
          'StartFailed': 'There was an issue starting your chat session. Please verify your connection and that you submitted all required information properly, then try again.',
          'MessageFailed': 'Your message was not received successfully. Please try again.',
          'RestoreFailed': 'We\'re sorry but we were unable to restore your chat session due to an unknown error.',
          'TransferFailed': 'Unable to transfer chat at this time. Please try again later.',
          'FileTransferSizeError': 'The file could not be sent.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>File size is larger than the allowed size (<%MaxSizePerFile%>).</p>',
          'InviteFailed': 'Unable to generate invite at this time. Please try again later.',
          'ChatServerWentOffline': 'Messages are currently taking longer than normal to get through. We\'re sorry for the delay.',
          'RestoredOffline': 'Messages are currently taking longer than normal to get through. We\'re sorry for the delay.',
          'Disconnected': '<div style=\'text-align:center\'>Connection lost</div>',
          'Reconnected': '<div style=\'text-align:center\'>Connection restored</div>',
          'FileSendFailed': 'The file could not be sent.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'><%FilenameTruncated%></p></strong><p class=\'cx-advice\'>There was an unexpected disconnection. Try again?</p>',
          'Generic': '<div style=\'text-align:center\'>An unexpected error occurred.</div>',
          'pureengage-v3-rest-INVALID_FILE_TYPE': 'Invalid file type. Only Images are allowed.',
          'pureengage-v3-rest-LIMIT_FILE_SIZE': 'File size is larger than the allowed size.',
          'pureengage-v3-rest-LIMIT_FILE_COUNT': 'The maximum number of attached files exceeded the limit.',
          'pureengage-v3-rest-INVALID_CONTACT_CENTER': 'Invalid x-api-key transport configuration.',
          'pureengage-v3-rest-INVALID_ENDPOINT': 'Invalid endpoint transport configuration.',
          'pureengage-v3-rest-INVALID_NICKNAME': 'First Name is required.',
          'pureengage-v3-rest-AUTHENTICATION_REQUIRED': 'We\'re sorry but we are not able to authorize the chat session.',
          'purecloud-v2-sockets-400': 'Sorry, something went wrong. Please verify your connection and that you submitted all required information properly, then try again.',
          'purecloud-v2-sockets-500': 'We\'re are sorry, an unexpected error occurred with the service.',
          'purecloud-v2-sockets-503': 'We\'re sorry, the service is currently unavailable.',
          'pureconnect-v4-rest-400': 'Sorry, something went wrong. Please verify your connection and that you submitted all required information properly, then try again.',
          'pureconnect-v4-rest-500': 'We\'re sorry, an unexpected error occurred with the service.',
          'pureconnect-v4-rest-503': 'We\'re sorry, the service is currently unavailable.'
        }
      }
    }
  },
  es: {
    'transcriptClose': 'Cerrar la transcripción',
    'Unvisited Tab': 'Pestaña no visitada',
    'Visited Tab': 'Pestaña visitada',
    'backButton': 'Pagina Anterior',
    'forwardButton': 'Siguiente Página',
    'portraitModeWarning': 'Este curso está optimizado para verse en modo apaisado en teléfonos móviles. Por favor, intente rotar su teléfono.',
    'secondaryNavigationLabel': 'Navegación secundaria',
    'currentLanguage': 'Español',
    'off': 'Apagado',
    'closeModal': 'Cerrar',
    'actionPlan': {
      'viewMyPlan': 'Continue',
      'summaryText': 'Congratulations on completing your Action Plan! Select Continue to view your plan and have it emailed to you.',
      'stepDone': 'Done',
      'completeTitle': 'Plan de Acción completo',
      'sendEmail': 'Mándame por correo electrónico mi plan de acción',
      'emailPlaceholder': 'correo electrónico',
      'subheader': 'Montar un Plan de Acción',
      'stepsComplete': 'Step {{currentStep}} of {{totalSteps}}'
    },
    'alertBox': {
      'alertSuccessHeader': 'Enviado con éxito.',
      'alertSuccessText': 'Puede continuar con el curso.',
      'alertFailureHeader': 'Se produjo un error...',
      'alertFailureText': 'Se produjo un error al enviar esta política. Vuelva a intentarlo. Si tiene algún problema para completar el curso, póngase en contacto con un administrador.'
    },
    'actionPlanResponses': {
      'subheader': 'Viewing Action Plan',
      'stepsComplete': '{{doneTotal}} of {{responseTotal}} complete',
      'now': 'Ahora',
      'later': 'Más tarde',
      'done': 'Bien',
      'incomplete': 'Ver el plan de acción'
    },
    'dragAndDrop': {
      'single': 'Este es un elemento arrastrable. También puede usar el teclado para hacer selecciones: presione ENTER para mover este elemento al lugar de colocación correcto.',
      'multiple': 'Este es un elemento arrastrable. También puede usar el teclado para hacer selecciones: presione ENTER para seleccionarlo, luego presione una tecla de {{primera opción}} a {{última opción}} para mover este elemento.',
      'default': 'Lugar de caída',
      'linkWord': 'para',
      'dropped': 'Este elemento arrastrable ahora se descarta.',
      'dropSpotTaken': 'Drop spot ya tomado.',
      'success': 'Arrastrar elemento se cayó con éxito.',
      'incorrect': 'El elemento de arrastre no se ha caído. Punto de caída no correcto.'
    },
    'videoAccessibility': {
      'pause': 'Selecciona este botón para pausar el video',
      'play': 'Seleccione este botón para reproducir el video',
      'stopped': 'Video detenido, haga clic para reproducir',
      'playpause': 'Haga clic para pausar o reproducir medios',
      'mute': 'Seleccione esto para silenciar el video',
      'unmute': 'Seleccione esto para dejar de silenciar el video',
      'time': 'Tiempo de medios actual',
      'seeker': 'Avanzar o rebobinar los medios actuales',
      'duration': 'Duración de los medios',
      'captions': 'Alternar subtítulos multimedia',
      'volumebar': 'Ajustar el volumen de los medios',
      'tracks': 'Cambie las pistas A / V en los medios',
      'bitrate': 'Cambiar la tasa de bits de los medios',
      'autoSwitch': 'Cambio automático',
      'fullscreen': 'Alternar pantalla completa de medios',
      'keyboardShortcutsButton': 'Atajos de teclado',
      'keyboardShortcuts': '<p>Use la barra espaciadora o Enter para pausar/reproducir el video.</p><p>Use M para silenciar/activar el sonido del video.</p><p>Use la flecha hacia arriba y la flecha hacia abajo para subir/bajar el volumen.</p><p>Usa C para mostrar/ocultar los subtítulos.</p>',
      'keyboardShortcutsClose': 'Cerrar',
      'playerInstructions1': 'Este es un reproductor de video en ',
      'playerInstructions2': 'Use la barra espaciadora o Enter para pausar / reproducir el video. Use M para silenciar / activar el sonido del video. Use C para mostrar / ocultar los subtítulos. Use F para ir a pantalla completa. Use la flecha arriba y la flecha abajo para aumentar / disminuir el volumen. Use la flecha derecha y la flecha izquierda para saltar hacia adelante / atrás.',
      'minutes': 'minutos',
      'seconds': 'segundos',
      'timeLabel': '{{currentTime}} de {{duration}}'
    },
    'accordion': {
      'bellowCollapsed': 'Currently collapsed, press enter to expand this selection.',
      'bellowVisitedCollapsed': 'Visited Collapsed',
      'bellowVisitedExpanded': 'Currently Open',
    },
    'carousel': {
      'next': 'Anterior',
      'previous': 'Siguiente'
    },
    'sort': {
      'grabbed': '{{ srText }} grabbed',
      'dropped': '{{ srText }} dropped',
      'listUpdated': 'List updated. {{srText}} is now {{ position }} of {{ length }}'
    },
    'slider': {
      'decrementBtn': 'Disminuir control deslizante',
      'incrementBtn': 'Incrementar control deslizante'
    },
    'currentPage': 'Página actual',
    'selected': 'seleccionado',
    'link': {
      'newWindowWarning': 'advertencia: este link se abrirá en una ventana nueva'
    },
    'advocateChat': {
      'calendar': {
        'CalendarDayLabels': [
          'Domingo',
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado'
        ],
        'CalendarMonthLabels': [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'Mayo',
          'Jun',
          'Jul',
          'Ago',
          'Sept',
          'Oct',
          'Nov',
          'Dic'
        ],
        'CalendarLabelToday': 'Hoy',
        'CalendarLabelTomorrow': 'Mañana',
        'CalendarTitle': 'Programar una llamada',
        'CalendarOkButtonText': 'Aceptar',
        'CalendarError': 'No se puede obtener la información de disponibilidad.',
        'CalendarClose': 'Cancelar',
        'AriaWindowTitle': 'Ventana Calendario',
        'AriaCalendarClose': 'Cancele el Calendario y vuelva al Registro de devolución de llamadas',
        'AriaYouHaveChosen': 'Ha elegido',
        'AriaNoTimeSlotsFound': 'No se encontraron franjas horarias para la fecha seleccionada'
      },
      'callus': {
        'CallUsTitle': 'Llámenos',
        'ContactsHeader': 'Puede llamarnos a cualquiera de los siguientes números...',
        'CancelButtonText': 'Cancelar',
        'CoBrowseText': '<span class=\'cx-cobrowse-offer\'>¿Ya está en una llamada? Déjenos <a role=\'link\' tabindex=\'0\' class=\'cx-cobrowse-link\'>navegar con usted</a></span>.',
        'CoBrowse': 'Iniciar conavegación',
        'CoBrowseWarning': 'La conavegación le permite al agente ver y controlar su escritorio para ayudarlo y orientarlo. Cuando esté en una llamada en vivo con un agente, solicite un código para iniciar la conavegación e introdúzcalo a continuación. Si todavía no está en la llamada, abandone esta pantalla y regrese a la página Llámenos.',
        'SubTitle': 'Puede llamarnos a cualquiera de los siguientes números...',
        'AriaWindowLabel': 'Ventana Llámenos',
        'AriaCallUsClose': 'Cerrar Llámenos',
        'AriaBusinessHours': 'Horas de atención',
        'AriaCallUsPhoneApp': 'Abre la aplicación del teléfono',
        'AriaCobrowseLink': 'Abre la sesión de conavegación',
        'AriaCancelButtonText': 'Cancelar Llámenos'
      },
      'callback': {
        'CallbackTitle': 'Recibir una llamada',
        'CancelButtonText': 'Cancelar',
        'AriaCancelButtonText': 'Cancelar',
        'ConfirmButtonText': 'Confirmar',
        'AriaConfirmButtonText': 'Confirmar',
        'CallbackFirstName': 'Nombre',
        'CallbackPlaceholderRequired': 'Obligatorio',
        'CallbackPlaceholderOptional': 'Opcional',
        'CallbackLastName': 'Apellido',
        'CallbackPhoneNumber': 'Teléfono',
        'CallbackQuestion': '¿Cuándo lo podemos llamar?',
        'CallbackDayLabels': [
          'Domingo',
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado'
        ],
        'CallbackMonthLabels': [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'Mayo',
          'Jun',
          'Jul',
          'Ago',
          'Sep',
          'Oct',
          'Nov',
          'Dic'
        ],
        'CallbackConfirmDescription': 'Reserva completada!',
        'CallbackNumberDescription': 'Lo llamaremos al número indicado:',
        'CallbackNotes': 'Notas',
        'CallbackDone': 'Cerrar',
        'AriaCallbackDone': 'Cerrar',
        'CallbackOk': 'Aceptar',
        'AriaCallbackOk': 'Aceptar',
        'CallbackCloseConfirm': '¿Está seguro de que no desea continuar coordinando esta devolución de llamada?',
        'CallbackNoButtonText': 'No',
        'AriaCallbackNoButtonText': 'No',
        'CallbackYesButtonText': 'Sí',
        'AriaCallbackYesButtonText': 'Sí',
        'CallbackWaitTime': 'Tiempo de espera',
        'CallbackWaitTimeText': 'minutos de espera',
        'CallbackOptionASAP': 'Tan pronto como sea posible',
        'CallbackOptionPickDateTime': 'Seleccionar fecha y hora',
        'AriaCallbackOptionPickDateTime': 'Abre un selector de fechas',
        'CallbackPlaceholderCalendar': 'Seleccionar fecha y hora',
        'AriaMinimize': 'Minimizar devolución de llamada',
        'AriaWindowLabel': 'Ventana Devolución de llamadas',
        'AriaMaximize': 'Maximizar devolución de llamada',
        'AriaClose': 'Cerrar devolución de llamada',
        'AriaCalendarClosedStatus': 'Se cerró el calendario',
        'Errors': {
          '501': 'No se pueden aceptar parámetros no válidos. Consulte la documentación auxiliar sobre la API del servidor para obtener los parámetros válidos.',
          '503': 'Falta la clave API. Asegúrese de que esté configurada correctamente.',
          '1103': 'Falta la clave API. Asegúrese de que esté configurada correctamente.',
          '7030': 'Introducir un número de teléfono válido.',
          '7036': 'No es posible la devolución de llamada a este número. Inténtelo con otro número de teléfono.',
          '7037': 'No se permite la devolución de llamada a este número. Inténtelo con otro número de teléfono.',
          '7040': 'Configurar un nombre de servicio válido.',
          '7041': 'Hay demasiadas solicitudes en este momento.',
          '7042': 'Oficina cerrada. Intente planificar dentro del horario de atención.',
          'unknownError': 'Se produjo un error. Lamentamos el inconveniente. Verifique la configuración de la conexión e inténtelo de nuevo.',
          'phoneNumberRequired': 'Se requiere el número de teléfono.',
          'CallbackDateTimeRequired': 'Seleccionar fecha y hora'
        }
      },
      'channelselector': {
        'Title': 'Asistencia en vivo',
        'SubTitle': '¿Cómo desea ponerse en contacto?',
        'WaitTimeTitle': 'Tiempo de espera',
        'AvailableTitle': 'Disponible',
        'AriaAvailableTitle': 'Disponible',
        'UnavailableTitle': 'No disponible',
        'CobrowseButtonText': 'CobrowseSubTitle',
        'CallbackTitle': 'Recibir una llamada',
        'CobrowseSubTitle': 'Se necesita una conexión con el agente para esto.',
        'AriaClose': 'Cerrar el Asistente en vivo',
        'AriaWarning': 'Advertencia',
        'AriaAlert': 'Alerta',
        'minute': 'min',
        'minutes': 'min',
        'AriaWindowLabel': 'Ventana Asistente en vivo'
      },
      'clicktocall': {
        'Title': 'Clic para llamar',
        'FirstName': 'Nombre',
        'PlaceholderRequired': 'Obligatorio',
        'PlaceholderOptional': 'Opcional',
        'LastName': 'Apellido',
        'PhoneNumber': 'Teléfono',
        'WaitTime': 'Tiempo de espera',
        'FormCancel': 'Cancelar',
        'AriaFormCancel': 'Cancelar',
        'FormSubmit': 'Solicitar un número',
        'AriaFormSubmit': 'Solicitar un número',
        'PhoneLabel': 'Marcar ahora',
        'AriaPhoneTitle': 'Abre la aplicación del teléfono',
        'AccessLabel': 'Código de acceso',
        'ExpireLabel': 'El número caduca en',
        'AriaExpireLabel': 'Temporizador de caducidad',
        'DisplayClose': 'Cerrar',
        'AriaDisplayClose': 'Cerrar',
        'NetworkFail': 'Se produjo un error. Lamentamos el inconveniente. Verifique la configuración de la conexión e inténtelo de nuevo.',
        'NetworkRetry': 'Aceptar',
        'AriaNetworkRetry': 'Aceptar',
        'InvalidAccept': 'Aceptar',
        'AriaInvalidAccept': 'Aceptar',
        'PhoneExpired': 'El número de teléfono ha caducado.',
        'PhoneReRequest': 'Solicitar un nuevo número',
        'AriaPhoneReRequest': 'Solicitar un nuevo número',
        'LocalFormValidationEmptyPhoneNumber': 'Introduzca un número de teléfono.',
        'ConfirmCloseWindow': 'Tiene datos del formulario sin enviar. ¿Confirma que desea salir?',
        'AriaConfirmCloseCancel': 'No',
        'ConfirmCloseCancel': 'No',
        'AriaConfirmCloseConfirm': 'Sí',
        'ConfirmCloseConfirm': 'Sí',
        'AriaWindowLabel': 'Ventana Clic para llamar',
        'AriaMaximize': 'Maximizar Clic para llamar',
        'AriaMinimize': 'Minimizar Clic para llamar',
        'AriaClose': 'Cerrar Clic para llamar'
      },
      'cobrowse': {
        'agentJoined': 'El agente se ha unido a la sesión.',
        'youLeft': 'Ha abandonado la sesión. Se finalizará la conavegación.',
        'sessionTimedOut': 'Se ha agotado el tiempo de espera de la sesión. Se finalizará la conavegación.',
        'sessionInactiveTimedOut': 'Se ha agotado el tiempo de espera de la sesión. Se finalizará la conavegación.',
        'agentLeft': 'El agente ha abandonado la sesión. Se finalizará la conavegación.',
        'sessionError': 'Se ha producido un error inesperado. Se finalizará la conavegación.',
        'sessionStarted': 'Se ha iniciado la sesión de conavegación. Esperando a que el agente se conecte a la sesión…',
        'navRefresh': 'El agente ha actualizado la página. Recargando.',
        'navBack': 'El agente ha pulsado el botón "Atrás". Recargando la página.',
        'navForward': 'El agente ha pulsado el botón "Adelante". Recargando la página.',
        'navUrl': 'El agente ha solicitado la navegación. Recargando la página.',
        'navFailed': 'No se ha podido completar la solicitud de navegación del agente.',
        'toolbarContent': 'ID de sesión: {sessionId}',
        'contentMasked': 'El contenido se ha ocultado al agente.',
        'contentMaskedPartially': 'Parte del contenido se ha ocultado al agente.',
        'exitBtnTitle': 'Salir de la sesión de conavegación',
        'areYouOnPhone': '¿Está al teléfono con nuestro agente?',
        'areYouOnPhoneOrChat': '¿Está al teléfono o en el chat con nuestro agente?',
        'connectBeforeCobrowse': 'Debe estar conectado con nuestro agente para continuar con la conavegación. Llámenos o inicie un chat en vivo con nosotros y, a continuación, inicie de nuevo la conavegación.',
        'sessionStartedAutoConnect': 'Se ha iniciado la sesión de conavegación. Esperando a que el agente se conecte a la sesión…',
        'browserUnsupported': 'Lamentablemente, no se admite actualmente su navegador.<br><br> Los navegadores admitidos son: <ul><li><a target=\'_blank\' href=\'http://www.google.com/chrome\'>Google Chrome</a></li><li><a target=\'_blank\' href=\'http://www.firefox.com/\'>Mozilla Firefox</a></li><li><a target=\'_blank\' href=\'http://microsoft.com/ie\'>Internet Explorer 9 y superior</a></li><li><a target=\'_blank\' href=\'https://www.apple.com/safari\'>Safari 6 y superior</a></li></ul>',
        'chatIsAlreadyRunning': 'El chat ya se está ejecutando en otra página.',
        'modalYes': 'Sí',
        'modalNo': 'No'
      },
      'knowledgecenter': {
        'SidebarButton': 'Buscar',
        'SearchButton': 'Buscar',
        'Title': 'Formular una pregunta',
        'Ask': 'Preguntar',
        'AriaAsk': 'Preguntar',
        'Close': 'Cerrar',
        'AriaClose': 'Cerrar Buscar',
        'Categories': 'Categorías',
        'NoResults': 'No hay resultados.',
        'NoResultsTextUnder': 'Lo sentimos; no hemos encontrado una respuesta adecuada para usted.',
        'NoResultsTextRephrase': '¿Podría intentar reformular la pregunta?',
        'WasThisHelpful': '¿Le ha resultado útil?',
        'Yes': 'Sí',
        'No': 'No',
        'AriaYes': 'Sí',
        'AriaNo': 'No',
        'ArticleHelpfulnessYes': 'Utilidad del artículo: "Sí"',
        'ArticleHelpfulnessYesDesc': '¡Genial! Nos complace escuchar que el artículo le ha ayudado en su búsqueda. Que tenga un buen día.',
        'ArticleHelpfulnessNo': 'Utilidad del artículo: "No"',
        'ArticleHelpfulnessNoDesc': 'Lamentamos que el artículo no sea una buena opción para su búsqueda. Le agradecemos sus comentarios.',
        'TypeYourQuestion': 'Escriba la pregunta.',
        'Back': 'Atrás',
        'AriaBack': 'Volver a resultados de la búsqueda',
        'More': 'Más',
        'Error': 'Error.',
        'GKCIsUnavailable': 'El servidor del centro de conocimiento no está disponible actualmente.',
        'AriaClear': 'Borrar búsqueda',
        'AriaSearch': 'Buscar',
        'AriaWindowLabel': 'Ventana Buscar',
        'AriaSearchDropdown': 'Resultados sugeridos',
        'AriaSearchMore': 'Leer más sobre',
        'AriaResultsCount': 'Número total de resultados',
        'KnowledgeAgentName': 'Centro de conocimiento',
        'WelcomeMessage': 'Hola, le damos la bienvenida. Un agente en vivo estará con usted en breve. Mientras tanto, ¿puedo ayudarle con cualquier pregunta que pueda tener? Escriba una pregunta en el campo de entrada mostrado a continuación.',
        'SearchResult': 'Mientras espera a que se conecte un agente, estas son las respuestas más pertinentes para su consulta:',
        'NoDocumentsFound': 'Lo sentimos. No hay artículos que coincidan con su pregunta. ¿Desea realizar otra pregunta?',
        'SuggestedMessage': 'Se ha sugerido el siguiente elemento de conocimiento:',
        'OpenDocumentHint': 'haga clic en él para ver su contenido.',
        'SuggestedDocumentMessage': 'Se ha sugerido el documento \'<%DocTitle%>\'.',
        'FeedbackQuestion': '¿Le ha resultado útil?',
        'FeedbackAccept': 'Sí',
        'FeedbackDecline': 'No',
        'TranscriptMarker': 'Centro de conocimiento: ',
        'SearchMessage': 'Buscar con la consulta \'<%SearchQuery%>\'↲',
        'VisitMessage': 'Visitar para ver el documento\'<%VisitQuery%>\'',
        'OpenMessage': 'Se ha visto \'<%OpenQuery%>\'.',
        'AnsweredMessage': 'Los resultados de la consulta \'<%AnsweredQuery%>\' se han marcado como pertinentes.',
        'UnansweredMessage': 'Los resultados de la consulta \'<%UnansweredQuery%>\' se han marcado como sin respuesta.',
        'PositiveVoteMessage': 'Voto positivo para el documento \'<%VoteQuery%>\'.',
        'NegativeVoteMessage': 'Voto negativo para el documento \'<%VoteQuery%>\'.',
        'SuggestedMarker': 'Se ha sugerido el documento[^\\0]*?.'
      },
      'sendmessage': {
        'SendMessageButton': 'Enviar mensaje',
        'OK': 'Aceptar',
        'Title': 'Enviar mensaje',
        'PlaceholderFirstName': 'Obligatorio',
        'PlaceholderLastName': 'Obligatorio',
        'PlaceholderEmail': 'Obligatorio',
        'PlaceholderSubject': 'Obligatorio',
        'PlaceholderTypetexthere': 'Escriba su mensaje aquí...',
        'FirstName': 'Nombre',
        'LastName': 'Apellido',
        'Email': 'Correo electrónico',
        'Subject': 'Asunto',
        'Attachfiles': 'Adjuntar archivos',
        'AriaAttachfiles': 'El vínculo Adjuntar archivos abre un cuadro de diálogo para cargar archivos',
        'Send': 'Enviar',
        'AriaSend': 'Enviar mensaje',
        'Sent': 'Se ha enviado su mensaje...',
        'Close': 'Cerrar',
        'ConfirmCloseWindow': '¿Confirma que desea cerrar el widget Enviar mensaje?',
        'Cancel': 'Cancelar',
        'AriaMinimize': 'Minimizar Enviar mensaje',
        'AriaMaximize': 'Maximizar Enviar mensaje',
        'AriaWindowLabel': 'Ventana Enviar mensaje',
        'AriaClose': 'Cerrar Enviar mensaje',
        'AriaCloseAlert': 'Se cerró el cuadro Alerta',
        'AriaEndConfirm': 'Sí',
        'AriaEndCancel': 'Cancelar',
        'AriaOK': 'Aceptar',
        'AriaRemoveFile': 'Quitar el archivo',
        'AriaFileIcon': 'Archivo',
        'AriaFileSize': 'Tamaño del archivo',
        'Errors': {
          '102': 'Debe especificar su nombre.',
          '103': 'Debe especificar sus apellidos.',
          '104': 'Debe especificar un asunto.',
          '181': 'Debe especificar una dirección de correo electrónico.',
          '182': 'Debe especificar el texto del mensaje.',
          'connectionError': 'No se puede acceder al servidor. Inténtelo de nuevo.',
          'unknowError': 'Se produjo un error. Lamentamos el inconveniente. Verifique la configuración de la conexión e inténtelo de nuevo.',
          'attachmentsLimit': 'El número total de archivos adjuntos supera el límite: ',
          'attachmentsSize': 'El tamaño total de los archivos adjuntos supera el límite: ',
          'invalidFileType': 'Tipo de archivo no admitido. Cargue archivos de imagen, de texto, PDF y ZIP.',
          'invalidFromEmail': 'Correo electrónico no válido: dirección del remitente',
          'invalidMailbox': 'Correo electrónico no válido: dirección del destinatario'
        }
      },
      'sidebar': {
        'SidebarTitle': '¿Necesita ayuda?',
        'ChannelSelectorName': 'Asistencia en vivo',
        'ChannelSelectorTitle': 'Obtener ayuda de uno de nuestros agentes de inmediato',
        'SearchName': 'Buscar',
        'SearchTitle': 'Buscar',
        'OffersName': 'Ofertas',
        'OffersTitle': 'Ofertas',
        'CallUsName': 'Llámenos',
        'CallUsTitle': 'Detalles de Llámenos',
        'CallbackName': 'Devolución de llamada',
        'CallbackTitle': 'Recibir una llamada',
        'ClickToCallName': 'Clic para llamar',
        'ClickToCallTitle': 'Solicitar un número de teléfono de servicio al cliente',
        'SendMessageName': 'Enviar mensaje',
        'SendMessageTitle': 'Enviar mensaje',
        'WebChatName': 'Chat en vivo',
        'WebChatTitle': 'Chat en vivo',
        'AriaClose': 'Cerrar el menú Necesita ayuda'
      },
      'webchat': {
        'ChatButton': 'Chat',
        'ChatStarted': 'Chat iniciado',
        'ChatEnded': 'Chat finalizado',
        'AgentNameDefault': 'Agente',
        'AgentConnected': '<%Agent%> conectado',
        'AgentDisconnected': '<%Agent%> desconectado',
        'BotNameDefault': 'Bot',
        'BotConnected': '<%Bot%> conectado',
        'BotDisconnected': '<%Bot%> desconectado',
        'SupervisorNameDefault': 'Supervisor',
        'SupervisorConnected': '<%Agent%> conectado',
        'SupervisorDisconnected': '<%Agent%> desconectado',
        'AgentTyping': '...',
        'AriaAgentTyping': 'El agente está escribiendo',
        'AgentUnavailable': 'Lo sentimos; no hay ningún agente disponible. Inténtelo de nuevo más tarde.',
        'ChatTitle': 'Chat en vivo',
        'ChatEnd': 'X',
        'ChatClose': 'X',
        'ChatMinimize': 'Min.',
        'ChatFormFirstName': 'Nombre',
        'ChatFormLastName': 'Apellido',
        'ChatFormNickname': 'Apodo',
        'ChatFormEmail': 'Correo electrónico',
        'ChatFormSubject': 'Asunto',
        'ChatFormPlaceholderFirstName': 'Obligatorio',
        'ChatFormPlaceholderLastName': 'Obligatorio',
        'ChatFormPlaceholderNickname': 'Opcional',
        'ChatFormPlaceholderEmail': 'Opcional',
        'ChatFormPlaceholderSubject': 'Opcional',
        'ChatFormSubmit': 'Iniciar chat',
        'AriaChatFormSubmit': 'Iniciar chat',
        'ChatFormCancel': 'Cancelar',
        'AriaChatFormCancel': 'Cancelar el chat',
        'ChatFormClose': 'Cerrar',
        'ChatInputPlaceholder': 'Escriba su mensaje aquí.',
        'ChatInputSend': 'Enviar',
        'AriaChatInputSend': 'Enviar',
        'ChatEndQuestion': '¿Está seguro de que desea finalizar esta sesión de chat?',
        'ChatEndCancel': 'Cancelar',
        'ChatEndConfirm': 'Finalizar chat',
        'AriaChatEndCancel': 'Cancelar',
        'AriaChatEndConfirm': 'Fin',
        'ConfirmCloseWindow': '¿Está seguro de que desea cerrar el chat?',
        'ConfirmCloseCancel': 'Cancelar',
        'ConfirmCloseConfirm': 'Cerrar',
        'AriaConfirmCloseCancel': 'Cancelar',
        'AriaConfirmCloseConfirm': 'Cerrar',
        'ActionsDownload': 'Descargar transcripción',
        'ActionsEmail': 'Enviar transcripción por correo electrónico',
        'ActionsPrint': 'Imprimir transcripción',
        'ActionsCobrowseStart': 'Iniciar conavegación',
        'AriaActionsCobrowseStartTitle': 'Abre la sesión de conavegación',
        'ActionsSendFile': 'Adjuntar archivos',
        'AriaActionsSendFileTitle': 'El vínculo Adjuntar archivos abre un cuadro de diálogo para cargar archivos',
        'ActionsEmoji': 'Enviar emoji',
        'ActionsCobrowseStop': 'Salir de conavegación',
        'ActionsVideo': 'Invitar a chat de vídeo',
        'ActionsTransfer': 'Transferir',
        'ActionsInvite': 'Invitar',
        'InstructionsTransfer': 'Abra este enlace en otro dispositivo para transferir la sesión de chat</br></br><%link%>',
        'InstructionsInvite': 'Comparta este enlace con otra persona para agregarla a esta sesión de chat</br></br><%link%>',
        'InviteTitle': '¿Necesita ayuda?',
        'InviteBody': 'Díganos si podemos ayudarle.',
        'InviteReject': 'No, gracias',
        'InviteAccept': 'Iniciar chat',
        'AriaInviteAccept': 'Aceptar invitación y comenzar el chat',
        'AriaInviteReject': 'Rechazar la invitación',
        'ChatError': 'Hubo un problema al iniciar la sesión de chat. Inténtelo de nuevo.',
        'ChatErrorButton': 'Aceptar',
        'AriaChatErrorButton': 'Aceptar',
        'ChatErrorPrimaryButton': 'Sí',
        'ChatErrorDefaultButton': 'No',
        'AriaChatErrorPrimaryButton': 'Sí',
        'AriaChatErrorDefaultButton': 'No',
        'DownloadButton': 'Descargar',
        'AriaDownloadButton': 'Descargar el archivo',
        'FileSent': 'envió:',
        'FileTransferRetry': 'Reintentar',
        'AriaFileTransferRetry': 'Volver a intentar la transferencia del archivo',
        'FileTransferError': 'Aceptar',
        'AriaFileTransferError': 'Aceptar',
        'FileTransferCancel': 'Cancelar',
        'AriaFileTransferCancel': 'Cancelar la transferencia del archivo',
        'RestoreTimeoutTitle': 'Chat finalizado',
        'RestoreTimeoutBody': 'Se agotó el tiempo de espera de su sesión de chat anterior. ¿Desea iniciar una nueva?',
        'RestoreTimeoutReject': 'No, gracias',
        'RestoreTimeoutAccept': 'Iniciar chat',
        'AriaRestoreTimeoutAccept': 'Aceptar invitación y comenzar el chat',
        'AriaRestoreTimeoutReject': 'Rechazar la invitación',
        'EndConfirmBody': '¿Desea realmente finalizar la sesión de chat?',
        'EndConfirmAccept': 'Finalizar chat',
        'EndConfirmReject': 'Cancelar',
        'AriaEndConfirmAccept': 'Finalizar chat',
        'AriaEndConfirmReject': 'Cancelar',
        'SurveyOfferQuestion': '¿Desea participar en una encuesta?',
        'ShowSurveyAccept': 'Sí',
        'ShowSurveyReject': 'No',
        'AriaShowSurveyAccept': 'Sí',
        'AriaShowSurveyReject': 'No',
        'UnreadMessagesTitle': 'sin leer',
        'AriaYouSaid': 'Usted dijo',
        'AriaSaid': 'dijo',
        'AriaSystemSaid': 'El sistema dijo',
        'AriaWindowLabel': 'Ventana Chat en vivo',
        'AriaMinimize': 'Minimizar chat en vivo',
        'AriaMaximize': 'Maximizar chat en vivo',
        'AriaClose': 'Cerrar chat en vivo',
        'AriaEmojiStatusOpen': 'Se abrió el cuadro de diálogo para seleccionar emoji',
        'AriaEmojiStatusClose': 'Se cerró el cuadro de diálogo para seleccionar emoji',
        'AriaEmoji': 'emoji',
        'AriaCharRemaining': 'Caracteres restantes',
        'AriaMessageInput': 'Cuadro de mensaje',
        'AsyncChatEnd': 'Finalizar chat',
        'AsyncChatClose': 'Cerrar ventana',
        'AriaAsyncChatEnd': 'Finalizar chat',
        'AriaAsyncChatClose': 'Cerrar ventana',
        'DayLabels': [
          'Dom',
          'Lun',
          'Mar',
          'Mier',
          'Jue',
          'Vier',
          'Sáb'
        ],
        'MonthLabels': [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'Mayo',
          'Jun',
          'Jul',
          'Ago',
          'Sept',
          'Oct',
          'Nov',
          'Dic'
        ],
        'todayLabel': 'Hoy',
        'Errors': {
          '102': 'Debe especificar su nombre.',
          '103': 'Debe especificar sus apellidos.',
          '161': 'Introduzca su nombre.',
          '201': 'No se pudo enviar el archivo.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>Se superaría el máximo de archivos adjuntos (<%MaxFilesAllowed%>)</p>',
          '202': 'No se pudo enviar el archivo.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>Se superaría el límite de carga o máximo de adjuntos (<%MaxAttachmentsSize%>)</p>',
          '203': 'No se pudo enviar el archivo.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>El tipo de archivo no está permitido.</p>',
          '204': 'Lamentablemente su mensaje es muy largo. Escriba uno más corto.',
          '240': 'Lamentablemente no podemos iniciar un nuevo chat en este momento. Vuelva a intentarlo más tarde.',
          '364': 'Dirección de correo electrónico no válida.',
          '401': 'Lo sentimos, pero no podemos autorizar la sesión de chat. ¿Quiere iniciar un nuevo chat?',
          '404': 'Lo sentimos, pero no encontramos su sesión de chat anterior. ¿Quiere iniciar un nuevo chat?',
          '500': 'Lo sentimos, se produjo un error inesperado con el servicio. ¿Quiere cerrar la sesión e iniciar un nuevo chat?',
          '503': 'Lo sentimos, por el momento el servicio no está disponible o está ocupado. ¿Quiere cerrar la sesión e iniciar un nuevo chat?',
          'ChatUnavailable': 'Lamentablemente no podemos iniciar un nuevo chat en este momento. Vuelva a intentarlo más tarde.',
          'CriticalFault': 'La sesión de chat ha finalizado inesperadamente debido a un problema desconocido. Disculpe las molestias.',
          'StartFailed': 'Hubo un error al iniciar su sesión de chat. Verifique su conexión y que haya enviado toda la información requerida correctamente, e inténtelo de nuevo.',
          'MessageFailed': 'Su mensaje no se recibió correctamente. Inténtelo de nuevo.',
          'RestoreFailed': 'We\'re sorry but we were unable to restore your chat session due to an unknown error',
          'TransferFailed': 'No es posible transferir el chat en este momento. Vuelva a intentarlo más tarde.',
          'FileTransferSizeError': 'No se pudo enviar el archivo.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'>\'<%FilenameTruncated%>\'</p></strong><p class=\'cx-advice\'>El tamaño del archivo supera el máximo permitido (<%MaxSizePerFile%>)</p>',
          'InviteFailed': 'No es posible generar una invitación en este momento. Vuelva a intentarlo más tarde.',
          'ChatServerWentOffline': 'En este momento el envío de mensajes está tardando más de lo normal. Lamentamos el retraso.',
          'RestoredOffline': 'En este momento el envío de mensajes está tardando más de lo normal. Lamentamos el retraso.',
          'Disconnected': '<div style=\'text-align:center\'>Se perdió la conexión</div>',
          'Reconnected': '<div style=\'text-align:center\'>Se restableció la conexión</div>',
          'FileSendFailed': 'No se pudo enviar el archivo.<br/><strong><p class=\'filename\' title=\'<%FilenameFull%>\'><%FilenameTruncated%></p></strong><p class=\'cx-advice\'>Se produjo una desconexión inesperada. ¿Desea volver a intentarlo?</p>',
          'Generic': '<div style=\'text-align:center\'>Error inesperado.</div>',
          'pureengage-v3-rest-INVALID_FILE_TYPE': 'Tipo de archivo no válido. Solo se admiten imágenes.',
          'pureengage-v3-rest-LIMIT_FILE_SIZE': 'El tamaño del archivo es superior al máximo permitido.',
          'pureengage-v3-rest-LIMIT_FILE_COUNT': 'Se ha superado el número máximo de archivos adjuntos.',
          'pureengage-v3-rest-INVALID_CONTACT_CENTER': 'Configuración de transporte de x-api-key no válida',
          'pureengage-v3-rest-INVALID_ENDPOINT': 'Configuración de transporte de punto final no válida',
          'pureengage-v3-rest-INVALID_NICKNAME': 'Debe especificar su nombre.',
          'pureengage-v3-rest-AUTHENTICATION_REQUIRED': 'Lo sentimos, pero no podemos autorizar la sesión de chat.',
          'purecloud-v2-sockets-400': 'Lo sentimos; se ha producido un problema. Compruebe la conexión y que haya enviado correctamente toda la información necesaria. A continuación, inténtelo de nuevo.',
          'purecloud-v2-sockets-500': 'Lo sentimos; se ha producido un error inesperado con el servicio.',
          'purecloud-v2-sockets-503': 'Lo sentimos; el servicio no está disponible actualmente.',
          'pureconnect-v4-rest-400': 'Lo sentimos; se ha producido un problema. Compruebe la conexión y que haya enviado correctamente toda la información necesaria. A continuación, inténtelo de nuevo.',
          'pureconnect-v4-rest-500': 'Lo sentimos; se ha producido un error inesperado con el servicio.',
          'pureconnect-v4-rest-503': 'Lo sentimos; el servicio no está disponible actualmente.'
        }
      }
    }
  }
};
